'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');
var twilioVideo = require('twilio-video');

function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}

/**
 * hanya remote participant yang dapat didetect as dominant speaker
 * https://www.twilio.com/docs/video/detecting-dominant-speaker#javascript
 */
function useDominantSpeaker(_ref) {
  var room = _ref.room;
  var _useState = react.useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    dominantSpeaker = _useState2[0],
    setDominantSpeaker = _useState2[1];
  react.useEffect(function () {
    if (room) {
      var handleDominantSpeakerChanged = function handleDominantSpeakerChanged(participant) {
        return setDominantSpeaker(participant);
      };
      room.on('dominantSpeakerChanged', handleDominantSpeakerChanged);
      return function () {
        room.off('dominantSpeakerChanged', handleDominantSpeakerChanged);
      };
    }
  }, [room]);
  return {
    dominantSpeaker: dominantSpeaker
  };
}

/**
 * handle participant events
 *
 * References:
 * https://www.twilio.com/docs/video/javascript-getting-started#connect-to-a-room
 * https://www.twilio.com/docs/video/javascript-getting-started#handle-connected-participants
 */
function useParticipant(_ref) {
  var room = _ref.room,
    onNewParticipantConnected = _ref.onNewParticipantConnected,
    onParticipantDisconnected = _ref.onParticipantDisconnected;
  var _useState = react.useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    participants = _useState2[0],
    setParticipants = _useState2[1];
  var localParticipant = room && room.localParticipant;
  react.useEffect(function () {
    if (room) {
      /**
       * When Participants connect to or disconnect from a Room that you're connected to,
       * you'll be notified via Participant connection events
       */
      var handleAlreadyConnected = function handleAlreadyConnected(participant) {
        return setParticipants(function (p) {
          return [].concat(_toConsumableArray(p), [participant]);
        });
      };
      var handleNewConnected = function handleNewConnected(participant) {
        setParticipants(function (p) {
          return [].concat(_toConsumableArray(p), [participant]);
        });
        onNewParticipantConnected && onNewParticipantConnected(participant);
      };
      var handleParticipantDisconnected = function handleParticipantDisconnected(participant) {
        setParticipants(function (current) {
          return current.filter(function (p) {
            return p !== participant;
          });
        });
        onParticipantDisconnected && onParticipantDisconnected(participant);
      };

      // Log any Participants already connected to the Room
      room.participants.forEach(handleAlreadyConnected);
      // new participant connected
      room.on('participantConnected', handleNewConnected);
      room.on('participantDisconnected', handleParticipantDisconnected);
      return function () {
        room.off('participantConnected', handleNewConnected);
        room.off('participantDisconnected', handleParticipantDisconnected);
      };
    }
  }, [onNewParticipantConnected, onParticipantDisconnected, room]);
  return {
    localParticipant: localParticipant,
    remoteParticipants: participants
  };
}

var INITIAL_STATE = {
  room: null,
  error: null
};
function useRoomConnection() {
  var _useState = react.useState(INITIAL_STATE),
    _useState2 = _slicedToArray(_useState, 2),
    roomState = _useState2[0],
    setRoomState = _useState2[1];
  var room = roomState.room;

  /**
   * connect to a room
   */
  var connectRoom = react.useCallback(function (_ref) {
    var token = _ref.token,
      options = _ref.options;
    twilioVideo.connect(token, options).then(function (room) {
      setRoomState(function (c) {
        return _objectSpread2(_objectSpread2({}, c), {}, {
          room: room
        });
      });
      console.log("Successfully joined a Room: ".concat(room));
    })["catch"](function (error) {
      console.error("Unable to connect to Room: ".concat(error.message));
      setRoomState(function (c) {
        return _objectSpread2(_objectSpread2({}, c), {}, {
          error: error
        });
      });
    });
  }, []);

  /**
   * Disconnect from room
   */
  var disconnectRoom = react.useCallback(function () {
    if (room) {
      room.disconnect();
    }
  }, [room]);

  /**
   * handle on beforeunload & on pagehide
   */
  react.useEffect(function () {
    if (room) {
      window.addEventListener('beforeunload', disconnectRoom);
      window.addEventListener('pagehide', disconnectRoom);

      // remove listener
      room.once('disconnected', function () {
        window.removeEventListener('beforeunload', disconnectRoom);
        window.removeEventListener('pagehide', disconnectRoom);
      });
      return function () {
        window.removeEventListener('beforeunload', disconnectRoom);
        window.removeEventListener('pagehide', disconnectRoom);
      };
    }
  }, [disconnectRoom, room]);
  return _objectSpread2(_objectSpread2({}, roomState), {}, {
    disconnectRoom: disconnectRoom,
    connectRoom: connectRoom
  });
}

/**
 * Toggle on/off local participant camera
 *
 * References:
 * https://www.twilio.com/docs/video/javascript-getting-started#mute-your-local-media
 */
function useToggleCamera(_ref) {
  var room = _ref.room,
    initialState = _ref.initialState;
  var _useState = react.useState(initialState),
    _useState2 = _slicedToArray(_useState, 2),
    isCameraOn = _useState2[0],
    setIsCameraOn = _useState2[1];
  var toggleCamera = react.useCallback(function () {
    if (room) {
      if (isCameraOn) {
        // turn off
        room.localParticipant.videoTracks.forEach(function (publication) {
          publication.track.disable();
        });
        setIsCameraOn(false);
      } else {
        // turn on
        room.localParticipant.videoTracks.forEach(function (publication) {
          publication.track.enable();
        });
        setIsCameraOn(true);
      }
    }
  }, [isCameraOn, room]);
  return {
    isCameraOn: isCameraOn,
    toggleCamera: toggleCamera
  };
}

/**
 * Toggle on/off local participant microphone
 *
 * References:
 * https://www.twilio.com/docs/video/javascript-getting-started#mute-your-local-media
 */
function useToggleMicrophone(_ref) {
  var room = _ref.room,
    initialState = _ref.initialState;
  var _useState = react.useState(initialState),
    _useState2 = _slicedToArray(_useState, 2),
    isMicrophoneOn = _useState2[0],
    setIsMicrophoneOn = _useState2[1];
  var toggleMicrophone = react.useCallback(function () {
    if (room) {
      if (isMicrophoneOn) {
        // turn off
        room.localParticipant.audioTracks.forEach(function (publication) {
          publication.track.disable();
        });
        setIsMicrophoneOn(false);
      } else {
        // turn on
        room.localParticipant.audioTracks.forEach(function (publication) {
          publication.track.enable();
        });
        setIsMicrophoneOn(true);
      }
    }
  }, [isMicrophoneOn, room]);
  return {
    isMicrophoneOn: isMicrophoneOn,
    toggleMicrophone: toggleMicrophone
  };
}

function useRoom(_ref) {
  var enableAudio = _ref.enableAudio,
    enableVideo = _ref.enableVideo;
  var _useRoomConnection = useRoomConnection(),
    room = _useRoomConnection.room,
    error = _useRoomConnection.error,
    connectRoom = _useRoomConnection.connectRoom,
    disconnectRoom = _useRoomConnection.disconnectRoom;
  var _useParticipant = useParticipant({
      room: room
    }),
    localParticipant = _useParticipant.localParticipant,
    remoteParticipants = _useParticipant.remoteParticipants;
  var _useDominantSpeaker = useDominantSpeaker({
      room: room
    }),
    dominantSpeaker = _useDominantSpeaker.dominantSpeaker;
  var _useToggleCamera = useToggleCamera({
      room: room,
      initialState: enableVideo
    }),
    isCameraOn = _useToggleCamera.isCameraOn,
    toggleCamera = _useToggleCamera.toggleCamera;
  var _useToggleMicrophone = useToggleMicrophone({
      room: room,
      initialState: enableAudio
    }),
    isMicrophoneOn = _useToggleMicrophone.isMicrophoneOn,
    toggleMicrophone = _useToggleMicrophone.toggleMicrophone;
  return {
    room: room,
    error: error,
    connectRoom: connectRoom,
    disconnectRoom: disconnectRoom,
    localParticipant: localParticipant,
    remoteParticipants: remoteParticipants,
    dominantSpeaker: dominantSpeaker,
    isCameraOn: isCameraOn,
    toggleCamera: toggleCamera,
    isMicrophoneOn: isMicrophoneOn,
    toggleMicrophone: toggleMicrophone
  };
}

/**
 * participant track subscription
 */
function useTrackSubscription(_ref) {
  var participant = _ref.participant;
  var _useState = react.useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    videoTrack = _useState2[0],
    setVideoTrack = _useState2[1];
  var _useState3 = react.useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    audioTrack = _useState4[0],
    setAudioTrack = _useState4[1];
  react.useEffect(function () {
    if (participant) {
      /**
       * participant track subs
       */
      var trackSubscribed = function trackSubscribed(track) {
        if (track.kind === 'video') {
          setVideoTrack(track);
        } else if (track.kind === 'audio') {
          setAudioTrack(track);
        }
      };
      participant.tracks.forEach(function (publication) {
        if (publication.track) {
          trackSubscribed(publication.track);
        }
      });
      participant.on('trackSubscribed', trackSubscribed);

      /**
       * participant track unsubs
       */
      var trackUnsubscribed = function trackUnsubscribed(track) {
        if (track.kind === 'video') {
          setVideoTrack(null);
        } else if (track.kind === 'audio') {
          setAudioTrack(null);
        }
      };
      participant.on('trackUnsubscribed', trackUnsubscribed);
      return function () {
        participant.off('trackSubscribed', trackSubscribed);
        participant.off('trackUnsubscribed', trackUnsubscribed);
      };
    }
  }, [participant]);
  return {
    audioTrack: audioTrack,
    videoTrack: videoTrack
  };
}

function useTrackAudio(_ref) {
  var audioTrack = _ref.audioTrack;
  var _useState = react.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    audioOn = _useState2[0],
    setAudioOn = _useState2[1];
  react.useEffect(function () {
    if (audioTrack) {
      setAudioOn(audioTrack.isEnabled);
      var handleAudioDisabled = function handleAudioDisabled() {
        setAudioOn(false);
      };
      var handleAudioEnabled = function handleAudioEnabled() {
        setAudioOn(true);
      };
      audioTrack.on('disabled', handleAudioDisabled);
      audioTrack.on('enabled', handleAudioEnabled);
      return function () {
        audioTrack.off('disabled', handleAudioDisabled);
        audioTrack.off('enabled', handleAudioEnabled);
      };
    }
  }, [audioTrack]);
  return {
    audioOn: audioOn
  };
}

function useTrackVideo(_ref) {
  var videoTrack = _ref.videoTrack;
  var _useState = react.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    videoOn = _useState2[0],
    setVideoOn = _useState2[1];
  react.useEffect(function () {
    if (videoTrack) {
      // initial state video
      setVideoOn(videoTrack.isEnabled);
      var handleVideoDisabled = function handleVideoDisabled() {
        setVideoOn(false);
      };
      var handleVideoEnabled = function handleVideoEnabled() {
        setVideoOn(true);
      };
      videoTrack.on('disabled', handleVideoDisabled);
      videoTrack.on('enabled', handleVideoEnabled);
      return function () {
        videoTrack.off('disabled', handleVideoDisabled);
        videoTrack.off('enabled', handleVideoEnabled);
      };
    }
  }, [videoTrack]);
  return {
    videoOn: videoOn
  };
}

function useTrack(_ref) {
  var participant = _ref.participant;
  var _useTrackSubscription = useTrackSubscription({
      participant: participant
    }),
    audioTrack = _useTrackSubscription.audioTrack,
    videoTrack = _useTrackSubscription.videoTrack;
  var _useTrackAudio = useTrackAudio({
      audioTrack: audioTrack
    }),
    audioOn = _useTrackAudio.audioOn;
  var _useTrackVideo = useTrackVideo({
      videoTrack: videoTrack
    }),
    videoOn = _useTrackVideo.videoOn;
  return {
    audioTrack: audioTrack,
    videoTrack: videoTrack,
    audioOn: audioOn,
    videoOn: videoOn
  };
}

exports.useRoom = useRoom;
exports.useTrack = useTrack;
//# sourceMappingURL=index.js.map
